
import { makeAutoObservable, runInAction } from 'mobx';
import { IMap, IMapParams } from 'src/@types/Choqorak/MainTables/Map/Map';
import agent from 'src/api/agent';
export default class MapStore {
  openDialog = false;

  MapRegistry = new Map<number, IMap>();

  editMode = false; //When click on edit button

  selectedMap: IMap | undefined = undefined;

  totalRecord: number = 0;

  constructor() {
    makeAutoObservable(this);
  }

  get MapList() {
    return Array.from(this.MapRegistry.values());
  }

  setMapList = (Map: IMap) => {
    this.MapRegistry.set(Map.id!, Map);
  };

  

  //Pagination
  loadMap = async (params: IMapParams) => {
   // this.MapRegistry.clear();
    try {
      const result = await agent.Map.getList(params);
      runInAction(() => {
        this.totalRecord = result.data.totalRecord;
        const reversed=result.data.data.reverse();
        reversed.forEach((lst: any) => {
          this.setMapList(lst);
        });
      });
    } catch (error) {
      console.log(error);
    }
  };

  // Search
  MapSearch = async (params: IMapParams) => {
    //this.MapRegistry.clear();
    this.loadMap(params);
  };

  getMapFromRegistry = (id: number) => {
    let Map = this.MapRegistry.get(id);
    if (Map) {
      this.editMode = true;
      this.selectedMap = Map;
    }
  };

  clearSelectedMap = () => {
    this.editMode = false;
    this.selectedMap = undefined;
  };

  deleteMap = async (id: number, remark?: string) => {
    try {
      await agent.Map.delete(id, remark!);
      runInAction(() => {
        this.MapRegistry.delete(id);
        this.totalRecord--;
        this.setOpenCloseDialog();
      });
    } catch (error) {
      console.log(error);
    }
  };

  setOpenCloseDialog = () => (this.openDialog = !this.openDialog);

  createMap = async (Map: IMap) => {
    try {
      await agent.Map.create(Map);
      runInAction(() => {
        this.loadMap({ pageIndex: 0, pageSize: 5 });
        this.clearSelectedMap();
      });
    } catch (error) {
      console.log(error);
    }
  };

  updateMap = async (Map: IMap) => {
    try {
      await agent.Map.update(Map);

      runInAction(() => {
        this.loadMap({ pageIndex: 0, pageSize: 5 });
        this.MapRegistry.delete(Map.id!);
        this.MapRegistry.set(Map.id!, Map);
        this.clearSelectedMap();

      });
    } catch (error) {
      console.log(error);
    }
  };
}
